<template>
  <div class="event-button-delete" @click="remove">
    イベントを削除
  </div>
</template>

<script>
export default {
  methods: {
    remove: function () {
      if (window.confirm('本当に削除しますか？')) {
        this.$router.go(-1)
        this.$store.dispatch('event/deleteEvent')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.event-button-delete {
  @include button-ol-danger;
}
</style>
